import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import SignupChoice from '../components/Auth/SignupChoice';

const LoginPage = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 320);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 320);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Add meta robots tag to prevent spam indexing
  useEffect(() => {
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex,nofollow';
    document.head.appendChild(metaRobots);

    return () => {
      // Cleanup: remove the meta tag when component unmounts
      const existingMeta = document.querySelector('meta[name="robots"]');
      if (existingMeta) {
        document.head.removeChild(existingMeta);
      }
    };
  }, []);

  const handleLegalPage = (page) => {
    switch (page) {
      case 'age-verification':
        navigate('/legal/age-verification');
        break;
      case 'terms':
        navigate('/legal/terms-of-service');
        break;
      case 'transactions':
        navigate('/legal/transaction-law');
        break;
      case 'privacy':
        navigate('/legal/privacy-policy');
        break;
      default:
        navigate('/legal/age-verification');
    }
  };

  return (
    <div style={{ 
      
      minHeight: '100vh',
      overflowY:'hidden',
      backgroundColor: '#f7d4b1ff',
      backgroundImage: 'linear-gradient(50deg, #f0f0f0 25%, transparent 25%), linear-gradient(-45deg, #f0f0f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f0f0f0 75%), linear-gradient(-45deg, transparent 75%, #f0f0f0 75%)',
      backgroundSize: '20px 20px',
      backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
      // minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Improved Header */}
      <header style={{
        height: isMobile ? '50px' : '80px',
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.16)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 20px rgba(0, 0, 0, 0.49)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: isMobile ? '0 15px' : '0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: isMobile ? '10px' : '15px',
          // flexDirection: isMobile ? 'column' : 'row'
        }}>
          <div style={{
            backgroundColor: '#ffd700',
            padding: isMobile ? '8px 15px' : '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)'
          }}>
            <h1 style={{ 
              color: 'white', 
              margin: 0, 
              fontSize: isMobile ? '20px' : '28px',
              fontWeight: 'bold',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}>
              STYLE
            </h1>
          </div>
          {/* {!isMobile && ( */}
            <div style={{
              borderLeft: '2px solid #ffd700',
              height: '40px',
              margin: '0 10px'
            }}></div>
          {/* )} */}
          <div style={{
            textAlign: 'center'
          }}>
            <h2 style={{
              margin: 0,
              fontSize: isMobile ? '14px' : '18px',
              color: '#2c3e50',
              fontWeight: '600'
            }}>
              素敵な出会いに
            </h2>
            <p style={{
              margin: '2px 0 0 0',
              fontSize: isMobile ? '11px' : '14px',
              color: '#7f8c8d',
              fontWeight: '400'
            }}>
              STYLE VS
            </p>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div style={{ 
        flex: 1,
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: isMobile ? '15px' : '20px'
      }}>
        <div style={{
          marginTop: isMobile ? '15px' : '25px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          padding: isMobile ? '20px' : '30px',
          borderRadius: '15px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          maxWidth: isMobile ? '95%' : '500px',
          width: '90%',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <LoginForm />
        </div>
        
        <div style={{ 
          marginTop: '5px', 
          textAlign: 'center',
          maxWidth: '800px'
        }}>
          <div style={{
            // backgroundColor: 'rgba(255, 255, 255, 0.8)',
            padding: '15px',
            borderRadius: '10px',
            // marginBottom: '15px'
          }}>
            <p style={{ 
              color: '#666', 
              fontSize: '14px', 
              margin: '0 0 10px 0',
              lineHeight: '1.5'
            }}>
              旧デザインから移行の方で、ログインが出来ない方、IDやパスワードが分からない方は
              <a 
                href="mailto:nwo123123@yahoo.co.jp?subject=ログインに関するお問い合わせ&body=旧デザインから移行の方で、ログインが出来ない方、IDやパスワードが分からない方からのお問い合わせです。%0D%0A%0D%0A【お客様情報】%0D%0Aお名前：%0D%0AユーザーID（旧デザイン）：%0D%0Aメールアドレス：%0D%0A電話番号：%0D%0A%0D%0A【お問い合わせ内容】%0D%0A詳細をお聞かせください：%0D%0A%0D%0A%0D%0A【その他】%0D%0Aその他ご質問やご不明な点がございましたら、こちらにご記入ください：%0D%0A%0D%0A%0D%0A---%0D%0AこのメールはSTYLE VSのログインページから送信されました。"
                style={{
                  color: '#ff6b35',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                onClick={(e) => {
                  // Ensure the mailto link works properly
                  e.preventDefault();
                  window.location.href = e.target.href;
                }}
              >
                こちら
              </a>
              からお問い合わせ下さい。
            </p>
            <p style={{ 
              color: '#e74c3c', 
              fontSize: '12px', 
              margin: 0,
              fontWeight: 'bold'
            }}>
              ※旧デザインのIDは使用できませんのでご注意下さい
            </p>
          </div>
          
          <SignupChoice />
        </div>
      </div>

      {/* Footer */}
      <footer style={{
        height: isMobile ? "80px" : "66px", 
        width: '100%', 
        fontSize: isMobile ? '11px' : '13px', 
        backgroundColor: 'rgba(44, 41, 41, 0.95)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(10px)',
        padding: isMobile ? '10px' : '0px'
      }}>
        <div style={{
          marginBottom: '8px'
        }}>
          {/* <a 
            onClick={() => handleLegalPage('age-verification')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            年齢認証に関して
          </a>
          <span style={{ color: '#777676' }}>|</span> */}
          <a 
            onClick={() => handleLegalPage('terms')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
            
          >
            利用規約
          </a>
          <span style={{ color: '#777676' }}>|</span>
          <a 
            onClick={() => handleLegalPage('transactions')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            特定商取引法に基く表記
          </a>
          <span style={{ color: '#777676' }}>|</span>
          <a 
            onClick={() => handleLegalPage('privacy')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            プライバシーポリシー
          </a>
        </div>
        <div style={{
          color: '#747272',
          fontSize: '12px'
        }}> 
          Copyright © 2025 スタート. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default LoginPage; 